import { HeaderPostsOptionsType } from "@/types/ModuleOptionsType";
import { ParentsType } from "../../../wp/getParentPages";

import { Breadcrumbs } from "@/components/Breadcrumbs/Breadcrumbs";
import { Post } from "@/wp/types/client";
import { ImageType } from "@/types/baseTypes";
import { ContentTag } from "@/components/ContentTag/ContentTag";
import { getCategories } from "@/wp/getCategory";
import { useState, useEffect } from "react";
import { Headline } from "@/components/Headline/Headline";
import { MediaItemResponsive } from "@/components/MediaItem/MediaItemResponsive";
import { BlogPostHeader } from "../BlogPostHeader/BlogPostHeader";
import { ExtendedLink } from "@/components/ExtededLink/ExtendedLink";

export interface PressHeaderProps {
  post: Post<"press">;
  headerOptions?: HeaderPostsOptionsType;
  parents: ParentsType;
  fallbackImg?: ImageType | false;
}

export const PressHeader = ({
  post,
  headerOptions,
  parents,
  fallbackImg,
}: PressHeaderProps) => {
  const header = post.acf.header_press;
  const {
    content,
    link_extended,
    seo_settings: { breadcrumb_title },
    background_color_class,
    headline_text_align_class,
  } = header;

  const { button_type, breadcrumb_position } = headerOptions ?? {};

  /* jscpd:ignore-end */
  const date = new Date(post.date_gmt).toLocaleDateString("de-DE", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  const [pressCategories, setPressCategories] = useState<string[]>([]);
  useEffect(() => {
    async function fetchCat() {
      const categories = await getCategories({ category: "press_category" });
      setPressCategories(
        categories
          .filter((cat) => post?.press_category?.includes(cat.id))
          .map((cat) => cat.name),
      );
    }
    fetchCat();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Always show category and date for blog posts in format: CATEGORY | DATE
  const categoryDateOverline = `${pressCategories.length > 0 ? pressCategories.join(" | ").toUpperCase() : ""}${pressCategories.length > 0 ? " | " : ""}${date}`;

  const breadcrumbsJSX = (
    <div className="nav-oriented-breadcrumbs">
      <Breadcrumbs
        parents={parents}
        // post={post}
        breadcrumbPositon={
          breadcrumb_position ?? "is-justify-content-flex-start"
        }
        breadcrumbTitle={breadcrumb_title}
      />
    </div>
  );
  const mediaJSX =
    header.image || fallbackImg ? (
      <MediaItemResponsive
        image_desktop={header.image ? header.image : fallbackImg || false}
        sizes="(max-width: 767px) 50vw, 100vw"
        priority={true}
      />
    ) : (
      <></>
    );

  const contentJSX = (
    <>
      <span className={"category-date-overline"}>{categoryDateOverline}</span>
      <Headline
        headline={header.title}
        headline_html_tag="h1-posts"
        extraClass={`is-flex is-flex-direction-column ${headline_text_align_class}`}
        disableAnimation
      />
      {mediaJSX}
      {content && <ContentTag extraClass="intro-text" content={content} />}
      {link_extended && (
        <ExtendedLink
          extendedLink={link_extended}
          btnType={button_type ?? "primary"}
        />
      )}
    </>
  );

  return (
    <BlogPostHeader
      breadcrumbsJSX={breadcrumbsJSX}
      contentJSX={contentJSX}
      sectionClassName={`${background_color_class}`}
    />
  );
};
